const AssociatedBrandsConstants = {
  GLOBAL : "global",
}

export default AssociatedBrandsConstants